"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serverSideAndClientSideTestNames = exports.allAbTests = void 0;
/** All known AB Tests. Other parts of the code need to know ALL of the choices for an AB test, so that it can
 * generate the key used for local storage.
 *
 * Choices may be assigned on the client side or the server side. Some are saved into the abtest_variant column.
 */
exports.allAbTests = {
    // Test names and values should be deleted from here when the test finishes
    // AB test groups where choices are assigned on the client side and may be saved into the abtest_variant column through an API call
    EnterFlowProgress: [
        { choice: 'CONTROL', weight: 1 },
        { choice: 'VARIANT1', weight: 1 },
        { choice: 'VARIANT2', weight: 0 },
        { choice: 'VARIANT3', weight: 0 },
    ],
    HomePageHeroTextSep2025: [
        { choice: 'CONTROL', weight: 1 },
        { choice: 'V1', weight: 1 },
        { choice: 'V2', weight: 0 },
        { choice: 'V3', weight: 1 },
        { choice: 'V4', weight: 0 },
        { choice: 'V5', weight: 0 },
        { choice: 'V6', weight: 1 },
        { choice: 'V7', weight: 0 },
        { choice: 'V8', weight: 1 },
    ],
    AllPrizesPage2026: [
        { choice: 'CONTROL', weight: 1 },
        { choice: 'VARIANT1', weight: 1 },
        { choice: 'VARIANT2', weight: 1 },
    ],
    Dashboard2026: [
        { choice: 'CONTROL', weight: 0.5 },
        { choice: 'V1', weight: 0.5 },
    ],
    ChooseYourPlanBoost: [
        { choice: 'CONTROL', weight: 1 },
        { choice: 'V3', weight: 1 },
    ],
    // AB test groups where choices are assigned on the server side
    MonthlyGiveaway: [
        { choice: 'CONTROL', weight: 1 },
        { choice: 'YES', weight: 1 },
    ],
    ConsolationPrize: [
        { choice: 'CONTROL', weight: 1 },
        { choice: 'YES', weight: 4 },
    ],
    PlasmicEnterFlow: [
        { choice: 'CONTROL', weight: 0 },
        { choice: 'V1', weight: 1 },
    ],
};
/** A list of the AB tests that must be synced between frontend and backend */
exports.serverSideAndClientSideTestNames = [
    // Test names should be deleted from here when the test finishes
    'AllPrizesPage2026',
];
//# sourceMappingURL=abTests.js.map